<template>
<div class="max-w-6xl mx-auto mb-12">
  <div class="flex sm:space-x-10 p-8 mx-10 border-dashed border-4 border-style">
    <img src="@/assets/announcement.svg" alt="公告" class="hidden sm:block test-pic"/>
    <p class="text-left text-lg">本館為建置更完善的分類系統，提供更佳的查詢服務，徵求您將多餘的或計畫回收的分類相關書籍、文物與資料寄贈本館，
      讓這些寶貴資料能發揮最大的功效。如欲提供，敬請連繫本館電子信箱&ensp;<span class="text-color">taie@tbri.gov.tw</span>&ensp;</p>
  </div>
</div>
</template>

<script>
export default {
  name: "Announcement",
};
</script>

<style scoped>
.text-color{
  color: #608BB2;
}

.border-style{
  border-color: #64859D;
  border-radius: 30px;
}
</style>
